import { render, staticRenderFns } from "./TransferredValuePassReport.vue?vue&type=template&id=821dfe52&"
import script from "./TransferredValuePassReport.vue?vue&type=script&lang=js&"
export * from "./TransferredValuePassReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports